import { Injectable } from '@angular/core';
import { removeOAuthLoadingOverlay, showOAuthLoadingOverlay } from '../../shared/oauth-loading-overlay';
import { StorageService } from '../storage/storage.service';

@Injectable({ providedIn: 'root' })
export class OAuthLoadingOverlayService {
  constructor(private storageService: StorageService) {}

  show(): void {
    showOAuthLoadingOverlay();
  }

  remove(): void {
    this.storageService.removeSessionStorageItem('oauth_callback_loading');
    this.storageService.removeSessionStorageItem('oauth_logout_loading');
    removeOAuthLoadingOverlay();
  }

  setLoginFlag(): void {
    this.storageService.setSessionStorageItem('oauth_callback_loading', 'true');
  }

  setLogoutFlag(): void {
    this.storageService.setSessionStorageItem('oauth_logout_loading', 'true');
  }
}
